import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { connect } from 'react-redux'
import i18n from 'simple-react-i18n'
import CampaignAction from '../../../../campaign/actions/CampaignAction'
import CampaignDto from '../../../../campaign/dto/CampaignDto'
import Checkbox from '../../../../components/forms/Checkbox'
import Input from '../../../../components/forms/Input'
import Select from '../../../../components/forms/Select'
import QualityAction from '../../../../quality/actions/QualityAction'
import DtoQualification from '../../../../quality/dto/DtoQualification'
import DtoStatus from '../../../../quality/dto/DtoStatus'
import ContributorAction from '../../../../referencial/components/contributor/actions/ContributorAction'
import ContributorDto from '../../../../referencial/components/contributor/dto/ContributorDto'
import FractionAction from '../../../../referencial/components/fraction/actions/FractionAction'
import FractionDto from '../../../../referencial/components/fraction/dto/FractionDto'
import SupportAction from '../../../../referencial/components/support/actions/SupportAction'
import SupportDto from '../../../../referencial/components/support/dto/SupportDto'
import { setModal } from '../../../../utils/FormUtils'
import Job from '../../../dto/DtoJob'
import ImportQualityDefaultValue from '../ImportQualityDefaultValue'
import ImportFileModal from './ImportFileModal'
import { getIntegrationModes } from '../../../../utils/JobUtils'
import { Grid } from '@mui/material'
import IntegrationModeDialog from '../IntegrationModeDialog'
import { isNil } from 'lodash'

const isEmptyCampaign = campaignId => isNil(campaignId) || campaignId === ''

class ImportEdiLaboPanel extends Component {
    constructor(props) {
        super(props)
        const parameter = props.job.parameters.parameters.length ? JSON.parse(props.job.parameters.parameters[0]) : {}
        this.state = {
            directory: undefined,
            filter: undefined,
            rename: false,
            unzipFiles: true,
            ...parameter,
        }
    }

    componentDidMount = () => {
        if (!this.props.contributors.length) {
            this.props.fetchContributors()
        }
        if (!this.props.qualifications.length) {
            this.props.fetchQualifications()
        }
        if (!this.props.status.length) {
            this.props.fetchStatus()
        }
        if (!this.props.fractions.length) {
            this.props.fetchFractions()
        }
        if (!this.props.supports.length) {
            this.props.fetchSupports()
        }
        this.props.fetchQualityCampaigns()
    }

    setAdvancedFtpModal = () => {
        setModal({
            title: i18n.importParam,
            content: <ImportFileModal url={this.state.directory} onChange={name => {
                this.onChangeParameter({ filter: name })
                this.setState({ filter: name })
            }}
            />,
        })
    }

    onChangeParameter = obj => {
        const newParameter = {
            ...this.state,
            ...obj,
        }
        this.setState(obj)
        this.props.handleChangeParameters([JSON.stringify(newParameter)])
    }

    getDataTypes = type => {
        const { parameters } = this.props.job
        if (parameters.dataTypes && parameters.dataTypes.length) {
            return parameters.dataTypes.find(d => d.includes(type)) || ''
        }
        return ''
    }

    handleChangeDataIntegration = integration => {
        const { parameters } = this.props.job
        const newDataTypes = (() => {
            const data = parameters.dataTypes.filter(d => !d.includes('DATA'))
            if (integration) {
                return [...data, integration]
            }
            return data
        })().filter(s => !s.includes('data'))
        this.props.onChangeDataTypes(newDataTypes)
    }

    render() {
        const {
            rename,
            histoPurge,
            campaignId,
            directory,
            filter,
            create,
            validation,
            dontProcessFilesInLogs,
            checkOriginCampaign,
            unzipFiles,
            ...defaultValue
        } = this.state
        const disabled = { disabled: !this.props.isEditMode }
        return (
            <>
                <Grid container spacing={2} alignItems='center' sx={{ paddingTop: 2, paddingBottom: 2 }}>
                    <Grid size={4}>
                        <Select
                            value={this.getDataTypes('DATA')}
                            options={getIntegrationModes()}
                            label={i18n.dataIntegration}
                            labelSpan={<IntegrationModeDialog />}
                            obligatory
                            onChange={this.handleChangeDataIntegration}
                            data-cy='integrationMode'
                            {...disabled}
                        />
                    </Grid>
                    <Grid size={4}>
                        <Select
                            value={campaignId}
                            keyValue='id'
                            options={this.props.qualityCampaigns.filter(cs => cs.campaignType === 3)}
                            label={i18n.campaign}
                            onChange={v => this.onChangeParameter(isEmptyCampaign(v) ? { campaignId: v } : { campaignId: v, checkOriginCampaign: false })}
                            data-cy='integrationCampagne'
                            {...disabled}
                        />
                    </Grid>
                    {isEmptyCampaign(campaignId) && (
                        <Grid size={4}>
                            <Checkbox
                                checked={checkOriginCampaign}
                                label={i18n.checkOriginCampaign}
                                onChange={v => this.onChangeParameter({ checkOriginCampaign: v })}
                                data-cy='checkOriginCampaign'
                                {...disabled}
                            />
                        </Grid>
                    )}
                    <Grid size={3}>
                        <Checkbox
                            checked={rename}
                            label={i18n.fileRenaming}
                            onChange={v => this.onChangeParameter({ rename: v })}
                            data-cy='renameFile'
                            {...disabled}
                        />
                    </Grid>
                    <Grid size={3}>
                        <Checkbox
                            checked={dontProcessFilesInLogs}
                            label={i18n.dontProcessFilesInLogs}
                            onChange={v => this.onChangeParameter({ dontProcessFilesInLogs: v })}
                            data-cy='notInJournal'
                            {...disabled}
                        />
                    </Grid>
                    <Grid size={3}>
                        <Checkbox
                            checked={histoPurge}
                            label={i18n.histoPurge}
                            onChange={v => this.onChangeParameter({ histoPurge: v })}
                            data-cy='purgeHisto'
                            {...disabled}
                        />
                    </Grid>
                    <Grid size={3}>
                        <Checkbox
                            checked={create}
                            label={i18n.noStationCreate}
                            onChange={v => this.onChangeParameter({ create: v })}
                            data-cy='createStation'
                            {...disabled}
                        />
                    </Grid>
                    <Grid size={3}>
                        <Checkbox
                            checked={unzipFiles}
                            label={i18n.unzipFiles}
                            onChange={v => this.onChangeParameter({ unzipFiles: v })}
                            data-cy='unzipFiles'
                            {...disabled}
                        />
                    </Grid>
                    <Grid size={9}>
                        <Checkbox
                            checked={validation}
                            label={i18n.formatValidationxsd + i18n.versionXsd1}
                            onChange={v => this.onChangeParameter({ validation: v })}
                            data-cy='validationXsd'
                            {...disabled}
                        />
                    </Grid>
                    <Grid size={6}>
                        <Input
                            title={i18n.selectDirectory}
                            value={directory}
                            obligatory
                            onChange={e => this.onChangeParameter({ directory: e })}
                            {...disabled}
                            data-cy='integrationDirectory'
                        />
                    </Grid>
                    <Grid size={2}>
                        <a className='btn btn-small secondary-color-back ' onClick={() => this.setAdvancedFtpModal()} >
                            <span title={i18n.importLabelFtp}>
                                <i className='material-icons'>input </i>
                            </span>
                        </a>
                    </Grid>
                    <Grid size={4}>
                        <Input
                            title={i18n.filter}
                            value={filter}
                            obligatory
                            onChange={e => this.onChangeParameter({ filter: e })}
                            data-cy='filter'
                            {...disabled}
                        />
                    </Grid>
                </Grid>
                <ImportQualityDefaultValue
                    defaultValue={defaultValue}
                    onChange={obj => this.onChangeParameter(obj)}
                    isEditMode={this.props.isEditMode}
                />
            </>
        )
    }
}

ImportEdiLaboPanel.propTypes = {
    job: PropTypes.instanceOf(Job).isRequired,
    isEditMode: PropTypes.bool,
    handleChangeParameters: PropTypes.func.isRequired,
    onChangeDataTypes: PropTypes.func.isRequired,
    contributors: PropTypes.arrayOf(PropTypes.instanceOf(ContributorDto)),
    qualifications: PropTypes.arrayOf(PropTypes.instanceOf(DtoQualification)),
    status: PropTypes.arrayOf(PropTypes.instanceOf(DtoStatus)),
    fractions: PropTypes.arrayOf(PropTypes.instanceOf(FractionDto)),
    supports: PropTypes.arrayOf(PropTypes.instanceOf(SupportDto)),
    qualityCampaigns: PropTypes.arrayOf(PropTypes.instanceOf(CampaignDto)),
    fetchContributors: PropTypes.func,
    fetchQualifications: PropTypes.func,
    fetchStatus: PropTypes.func,
    fetchFractions: PropTypes.func,
    fetchSupports: PropTypes.func,
    fetchQualityCampaigns: PropTypes.func,
}

const mapStateToProps = store => ({
    contributors: store.ContributorReducer.contributors,
    qualifications: store.QualityReducer.qualifications,
    status: store.QualityReducer.status,
    fractions: store.FractionReducer.fractions,
    supports: store.SupportReducer.supports,
    qualityCampaigns: store.QualityReducer.qualityCampaigns,
})

const mapDispatchToProps = {
    fetchContributors: ContributorAction.fetchContributors,
    fetchQualifications: QualityAction.fetchQualifications,
    fetchStatus: QualityAction.fetchStatus,
    fetchFractions: FractionAction.fetchFractions,
    fetchSupports: SupportAction.fetchSupports,
    fetchQualityCampaigns: CampaignAction.fetchQualityCampaigns,
}

export default connect(mapStateToProps, mapDispatchToProps)(ImportEdiLaboPanel)
